import { render, staticRenderFns } from "./app-item-container.vue?vue&type=template&id=1dd2ccec&scoped=true"
import script from "./app-item-container.vue?vue&type=script&lang=js"
export * from "./app-item-container.vue?vue&type=script&lang=js"
import style0 from "./app-item-container.vue?vue&type=style&index=0&id=1dd2ccec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2ccec",
  null
  
)

export default component.exports